<template>
  <page-loading
    v-if="loading"
    message="Carregando meus dados"
    subtitle="Buscando informações do seu perfil"
  />
  <div v-else class="partner-detail-page">
    <v-dialog v-model="dialog" width="800">
      <v-card
        width="800"
        height="800"
        class="d-flex align-center justify-content-center"
      >
        <figure v-if="dialogImageSrc">
          <img
            class="partner-detail-dialog-img"
            :src="dialogImageSrc"
            :alt="`Visualização da imagem`"
          />
        </figure>
      </v-card>
    </v-dialog>

    <v-tabs v-model="tab" class="partner-detail-tabs" background-color="white" color="primary" slider-color="primary" show-arrows>
      <v-tab>
        <v-icon left>mdi-account-details</v-icon>
        Dados Principais
      </v-tab>
      <v-tab>
        <v-icon left>mdi-map-marker</v-icon>
        Endereço
      </v-tab>
      <v-tab>
        <v-icon left>mdi-bank</v-icon>
        Dados Bancários
      </v-tab>
      <v-tab>
        <v-icon left>mdi-clock-outline</v-icon>
        Horários
      </v-tab>
      <v-tab>
        <v-icon left>mdi-information</v-icon>
        Informações Adicionais
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item class="spacing">
        <v-card class="partner-detail-card" elevation="0">
          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="
                    partner.typeCompany == 'PJ' ? 'Razão social' : 'Nome completo'
                  "
                  v-model="partner.name"
                  prepend-inner-icon="mdi-office-building"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="
                    partner.typeCompany == 'PJ'
                      ? 'Nome fantasia'
                      : 'Como quer ser chamado'
                  "
                  v-model="partner.nickname"
                  prepend-inner-icon="mdi-tag"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="partner.typeCompany == 'PJ' ? 'CNPJ' : 'CPF'"
                  v-model="partner.document"
                  v-mask="
                    partner.typeCompany == 'PJ'
                      ? '##.###.###/####-##'
                      : '###.###.###-##'
                  "
                  prepend-inner-icon="mdi-card-account-details"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4" v-if="partner.typeCompany === 'PJ'">
                <v-text-field
                  label="CNAE"
                  v-model="partner.cnaeCode"
                  prepend-inner-icon="mdi-file-document"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Email"
                  v-model="partner.email"
                  prepend-inner-icon="mdi-email"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Telefone"
                  v-model="partner.phone"
                  v-mask="'(##) #####-####'"
                  prepend-inner-icon="mdi-phone"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  label="Categoria"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  v-model="partner.categoryId"
                  prepend-inner-icon="mdi-tag-multiple"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card class="partner-detail-card" elevation="0">
          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  @blur="handleAddress"
                  label="CEP"
                  v-model="partner.address.zipCode"
                  v-mask="'#####-###'"
                  prepend-inner-icon="mdi-map-marker"
                  outlined
                  dense
                  class="br-form-field"
                  hint="Digite o CEP para buscar automaticamente"
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Logradouro"
                  v-model="partner.address.street"
                  prepend-inner-icon="mdi-road"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  label="Número"
                  v-model="partner.address.addressNumber"
                  prepend-inner-icon="mdi-numeric"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Bairro"
                  v-model="partner.address.neighborhood"
                  prepend-inner-icon="mdi-home-city"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Complemento"
                  v-model="partner.address.complement"
                  prepend-inner-icon="mdi-home-plus"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Cidade"
                  :required="true"
                  :disabled="true"
                  :readonly="true"
                  v-model="partner.address.cityName"
                  prepend-inner-icon="mdi-city"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  label="Estado"
                  :required="true"
                  :disabled="true"
                  :readonly="true"
                  v-model="partner.address.state"
                  prepend-inner-icon="mdi-map"
                  outlined
                  dense
                  class="br-form-field"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card class="partner-detail-card" elevation="0">
          <v-card-text class="pa-6">
            <v-card class="partner-detail-subcard mb-6" outlined>
              <v-card-title class="text-subtitle-1 pa-4">
                <v-icon left color="primary">mdi-bank-transfer</v-icon>
                Conexão PagBank
              </v-card-title>
              <v-card-text class="pa-4">
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="processor-logo-container mb-4">
                      <img
                        :src="pagBankLogoUrl"
                        alt="PagBank Logo"
                        class="processor-logo"
                        @error="handleLogoError('pagbank', $event)"
                      />
                    </div>
                    <h3 class="text-h6 mb-2">PagBank</h3>
                    <p class="subtitle-2 mb-3 partner-detail-muted">
                      Conecte sua conta PagBank para receber pagamentos diretamente em sua conta.
                    </p>
                    <v-chip
                      class="mb-4"
                      :color="pagBankStatus.pagbankConnect ? 'success' : 'error'"
                      text-color="white"
                      label
                    >
                      <v-icon left small>
                        {{ pagBankStatus.pagbankConnect ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                      </v-icon>
                      {{ pagBankStatus.pagbankConnect ? 'Conectado' : 'Não conectado' }}
                    </v-chip>

                    <v-btn
                      color="#00A859"
                      dark
                      large
                      block
                      @click="handleConnectPagBank"
                      :loading="connectingPagBank"
                      :disabled="connectingPagBank"
                    >
                      <v-icon left>{{ pagBankStatus.pagbankConnect ? 'mdi-refresh' : 'mdi-link' }}</v-icon>
                      {{ pagBankStatus.pagbankConnect ? 'Reconectar PagBank' : 'Conectar PagBank' }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card class="partner-detail-subcard" outlined>
                      <v-card-title class="text-subtitle-1 pa-3">
                        <v-icon left color="primary">mdi-key-variant</v-icon>
                        Chave Pix
                      </v-card-title>
                      <v-card-text class="pa-3">
                        <p class="caption mb-2 partner-detail-muted">
                          Informe a chave Pix utilizada para transferências diretas.
                        </p>
                        <v-text-field
                          v-model="partner.pixkey"
                          label="Chave Pix"
                          outlined
                          dense
                          hide-details="auto"
                          placeholder="CPF, CNPJ, e-mail, telefone ou aleatória"
                        />
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card class="partner-detail-card" elevation="0">
          <v-card-text class="pa-6">
            <!-- Formulário para adicionar horários -->
            <v-card class="partner-detail-subcard partner-detail-subcard--dashed mb-6" outlined>
              <v-card-title class="text-subtitle-1 pa-4">
                <v-icon left color="primary">mdi-plus-circle</v-icon>
                Adicionar Horário
              </v-card-title>
              <v-card-text class="pa-4">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-select
                      :items="day"
                      label="Dia da semana"
                      v-model="businessHoursDay"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      class="br-form-field"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      type="time"
                      label="Horário de abertura"
                      v-model="businessHoursStartTime"
                      prepend-inner-icon="mdi-clock-start"
                      outlined
                      dense
                      class="br-form-field"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      type="time"
                      label="Horário de fechamento"
                      v-model="businessHoursEndTime"
                      prepend-inner-icon="mdi-clock-end"
                      outlined
                      dense
                      class="br-form-field"
                    />
                  </v-col>
                  <v-col cols="12" md="1" class="d-flex align-end">
                    <v-btn
                      :disabled="
                        businessHoursDay == '' ||
                        businessHoursStartTime == '' ||
                        businessHoursEndTime == ''
                      "
                      color="primary"
                      large
                      icon
                      @click="handleAddBusinessHours"
                      class="add-button"
                      dark
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Tabela de horários -->
            <v-card class="partner-detail-subcard" outlined>
              <v-card-title class="text-subtitle-1 pa-4">
                <v-icon left color="primary">mdi-calendar-clock</v-icon>
                Horários Configurados
              </v-card-title>
              <v-data-table
                :headers="headersHours"
                :items="partner.businessHours"
                :items-per-page="7"
                class="br-data-table"
                no-data-text="Nenhum horário configurado"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item, index) in items" :key="index" class="table-row">
                      <td class="text-center">
                        <v-chip color="primary" dark outlined small>
                          {{ item.day }}
                        </v-chip>
                      </td>
                      <td class="text-center">
                        <v-icon left color="success">mdi-clock-start</v-icon>
                        {{ item.startTime }}
                      </td>
                      <td class="text-center">
                        <v-icon left color="error">mdi-clock-end</v-icon>
                        {{ item.endTime }}
                      </td>
                      <td class="text-center">
                        <v-btn
                          color="error"
                          text
                          icon
                          @click="handleDeleteBusinessHours(index)"
                          class="delete-button"
                        >
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card class="partner-detail-card" elevation="0">
          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  name="input-descricao-completa"
                  label="Descrição completa do negócio"
                  v-model="partner.description"
                  auto-grow
                  :rules="rulesDescricao"
                  rows="3"
                  no-resize
                  prepend-inner-icon="mdi-text"
                  outlined
                  dense
                  class="br-form-field"
                  hint="Descreva seu negócio de forma detalhada"
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Número do WhatsApp"
                  v-model="partner.whatsapp"
                  prepend-inner-icon="mdi-whatsapp"
                  v-mask="'(##) #####-####'"
                  outlined
                  dense
                  class="br-form-field"
                  hint="Número para contato via WhatsApp"
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Link do Instagram"
                  v-model="partner.instagram"
                  prepend-inner-icon="mdi-instagram"
                  hint="Ex: https://instagram.com/seunegocio"
                  outlined
                  dense
                  class="br-form-field"
                  persistent-hint
                />
              </v-col>

            <!-- Upload de imagens -->
            <v-col cols="12">
              <v-card class="partner-detail-subcard" outlined>
                <v-card-title class="text-subtitle-1 pa-4">
                  <v-icon left color="primary">mdi-image-multiple</v-icon>
                  Imagens do Negócio
                </v-card-title>
                <v-card-text class="pa-4">
                  <v-row>
                    <!-- Logo -->
                    <v-col cols="12" md="6">
                      <v-card class="partner-detail-subcard partner-detail-subcard--upload" outlined>
                        <v-card-title class="text-subtitle-2 pa-3">
                          <v-icon left color="primary">mdi-store</v-icon>
                          Logo do Negócio
                          <v-chip x-small dark color="primary" outlined class="ml-2">
                            512x512px
                          </v-chip>
                        </v-card-title>
                        <v-card-text class="pa-3">
                          <v-file-input
                            label="Selecionar Logo"
                            v-model="logoFile"
                            @change="handleConvertForBase64('LOGO')"
                            accept="image/*"
                            prepend-icon="mdi-camera"
                            clearable
                            @click:clear="removeImage('LOGO')"
                            outlined
                            dense
                            class="br-form-field"
                          />
                          <div v-if="getPreviewImage('LOGO')" class="image-preview-container">
                            <v-card class="image-preview-card" elevation="0">
                              <img
                                :src="getPreviewImage('LOGO')"
                                alt="Logo"
                                class="preview-image"
                                @click="openImageDialog(getPreviewImage('LOGO'))"
                              />
                              <v-btn
                                class="remove-image-btn"
                                color="error"
                                small
                                icon
                                @click="removeImage('LOGO')"
                              >
                                <v-icon>mdi-delete-outline</v-icon>
                              </v-btn>
                            </v-card>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- Banner -->
                    <v-col cols="12" md="6">
                      <v-card class="partner-detail-subcard partner-detail-subcard--upload" outlined>
                        <v-card-title class="text-subtitle-2 pa-3">
                          <v-icon left color="primary">mdi-image</v-icon>
                          Imagem de Banner
                          <v-chip x-small dark color="primary" outlined class="ml-2">
                            180x410px
                          </v-chip>
                        </v-card-title>
                        <v-card-text class="pa-3">
                          <v-file-input
                            label="Selecionar Banner"
                            v-model="coverFile"
                            @change="handleConvertForBase64('COVER')"
                            accept="image/*"
                            prepend-icon="mdi-camera"
                            clearable
                            @click:clear="removeImage('COVER')"
                            outlined
                            dense
                            class="br-form-field"
                          />
                          <div v-if="getPreviewImage('COVER')" class="image-preview-container">
                            <v-card class="image-preview-card" elevation="0">
                              <img
                                :src="getPreviewImage('COVER')"
                                alt="Banner"
                                class="preview-image"
                                @click="openImageDialog(getPreviewImage('COVER'))"
                              />
                              <v-btn
                                class="remove-image-btn"
                                color="error"
                                small
                                icon
                                @click="removeImage('COVER')"
                              >
                                <v-icon>mdi-delete-outline</v-icon>
                              </v-btn>
                            </v-card>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- Galeria -->
                    <v-col cols="12">
                      <v-card class="partner-detail-subcard partner-detail-subcard--upload" outlined>
                        <v-card-title class="text-subtitle-2 pa-3">
                          <v-icon left color="primary">mdi-image-multiple</v-icon>
                          Imagens de Publicidade
                          <v-chip x-small dark color="primary" outlined class="ml-2">
                            Até 3 imagens (1000x800px)
                          </v-chip>
                        </v-card-title>
                        <v-card-text class="pa-3">
                          <v-file-input
                            label="Selecionar Imagens de Publicidade"
                            v-model="galleryFiles"
                            @change="handleConvertForBase64('GALLERY', true)"
                            accept="image/*"
                            multiple
                            counter
                            show-size
                            :rules="[rulesMaxGalleryImages]"
                            prepend-icon="mdi-image-multiple"
                            clearable
                            @click:clear="clearGalleryFiles"
                            outlined
                            dense
                            class="br-form-field"
                          />
                          <v-row v-if="getPreviewImages('GALLERY').length > 0" class="mt-3">
                            <v-col
                              v-for="(image, index) in getPreviewImages('GALLERY')"
                              :key="index"
                              cols="6"
                              sm="4"
                              md="3"
                            >
                              <v-card class="gallery-preview-card" elevation="0">
                                <img
                                  :src="image"
                                  :alt="`Publicidade ${index + 1}`"
                                  class="gallery-preview-image"
                                  @click="openImageDialog(image)"
                                />
                                <v-btn
                                  class="gallery-remove-btn"
                                  color="error"
                                  small
                                  icon
                                  @click="removeImage('GALLERY', index)"
                                >
                                  <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs-items>

    <!-- Botão de salvar alinhado à direita -->
    <div class="d-flex justify-end mt-6">
      <v-btn
        color="primary"
        large
        class="update-button"
        @click="handleUpdatePartner()"
        :loading="isProcessingImage"
        dark
      >
        <v-icon left>mdi-content-save</v-icon>
        Salvar Alterações
      </v-btn>
    </div>
    <PagBankConnectDialog
      v-model="showPagBankConnectDialog"
      @connected="handlePagBankConnected"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { PartnerDetailsType, PartnerImage } from "@/types/partner/Partner";
import { GetPartner } from "@/services/partners/GetPartner";
import { GetAllCategories } from "@/services/partners/GetAllCategories";
import { UpdatePartner } from "@/services/partners/UpdatePartner";
import { GetAddress } from "@/services/viaCep/GetAddress";
import { GetPagBankStatus } from "@/services/partners/GetPagBankStatus";
import { validateOnboardingData } from "@/utils/onboardingChecklist";
import PagBankConnectDialog from "@/components/pagbank/PagBankConnectDialog.vue";
import PageLoading from "@/components/loading/PageLoading.vue";

export default defineComponent({
  components: {
    PagBankConnectDialog,
    PageLoading,
  },
  data() {
    return {
      tab: 0,
      rulesDescricao: [
        (v: string) => v.length <= 500 || "Máximo 500 caracteres",
      ],
      loading: true,
      partner: {
        id: "",
        name: "",
        status: "PENDING",
        nickname: "",
        tax: 5,
        typeCompany: "PJ",
        category: "",
        phone: "",
        email: "",
        document: "",
        pixkey: "",
        cnaeCode: "",
        address: {
          state: "",
          street: "",
          addressNumber: "",
          neighborhood: "",
          complement: "",
          zipCode: "",
          cityName: "",
          ibge: "",
        },
        users: [],
        user: {
          name: "",
          email: "",
          phone: "",
          document: "",
          password: "",
          nickname: "",
          birthdate: "",
          motherName: "",
        },
        associate: [],
        businessHours: [],
        createdAt: "",
        digitalAccountNumber: "",
        digitalAccountDocument: "",
        associates: [],
        categoryId: "",
        contractFile: "",
        registrationStatusFile: "",
        partnerConfigs: {
          id: 0,
          onlineSale: false,
          pdvSale: false,
          instantCashback: 0,
          updatedAt: "",
          greenBuy: false,
        },
        description: "",
        instagram: "",
        whatsapp: "",
        images: [],
      } as PartnerDetailsType,
      headersHours: [
        { text: "Dia", align: "center", value: "day" },
        { text: "Abertura", align: "center", value: "startTime" },
        { text: "Fechamento", align: "center", value: "endTime" },
        { text: "", align: "center", value: "actions" },
      ],
      businessHoursDay: "",
      businessHoursStartTime: "",
      businessHoursEndTime: "",
      day: [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
      ],
      categories: [],
      logoFile: null as File | null,
      coverFile: null as File | null,
      galleryFiles: [] as File[],
      dialog: false,
      dialogImageSrc: "",
      // Variáveis para URLs de preview de arquivos locais
      logoPreviewUrl: "" as string,
      coverPreviewUrl: "" as string,
      galleryPreviewUrls: [] as string[],
      originalPartnerImages: [] as PartnerImage[],
      isProcessingImage: false,
      connectingPagBank: false,
      showPagBankConnectDialog: false,
      pagBankLogoUrl: require("@/assets/pagbank-logo.png"),
      pagBankStatus: {
        connected: false,
        pagbankConnect: false,
        accountId: undefined as string | undefined,
        accountName: undefined as string | undefined,
      },
    };
  },
  methods: {
    handleAddBusinessHours() {
      this.partner.businessHours.push({
        day: this.businessHoursDay,
        endTime: this.businessHoursEndTime,
        startTime: this.businessHoursStartTime,
      });
      this.businessHoursDay = "";
      this.businessHoursEndTime = "";
      this.businessHoursStartTime = "";
    },
    handleDeleteBusinessHours(item: any) {
      this.partner.businessHours = this.partner.businessHours.filter(
        (element, index) => index !== item
      );
    },
    async handleGetDataPartner() {
      this.loading = true;
      const getPartner = new GetPartner();
      const partnerData = await getPartner.execute();

      this.partner.id = partnerData.id || "";
      this.partner.name = partnerData.name || "";
      this.partner.nickname = partnerData.nickname || "";
      this.partner.document = partnerData.document || "";
      this.partner.cnaeCode = partnerData.cnaeCode || "";
      this.partner.category = partnerData.category || "";
      this.partner.categoryId = partnerData.categoryId || "";
      this.partner.tax = partnerData.tax || 0;
      this.partner.status = partnerData.status;
      this.partner.createdAt = partnerData.createdAt || "";
      this.partner.digitalAccountDocument =
        partnerData.digitalAccountDocument || "";
      this.partner.digitalAccountNumber =
        partnerData.digitalAccountNumber || "";
      this.partner.pixkey = partnerData.pixkey || "";
      this.partner.phone = partnerData.phone || "";
      this.partner.email = partnerData.email || "";

      this.partner.address.street = partnerData.address?.street || "";
      this.partner.address.ibge = partnerData.address?.ibge || "";
      this.partner.address.addressNumber =
        partnerData.address?.addressNumber || "";
      this.partner.address.neighborhood =
        partnerData.address?.neighborhood || "";
      this.partner.address.complement = partnerData.address?.complement || "";
      this.partner.address.zipCode = partnerData.address?.zipCode || "";
      this.partner.address.cityName = partnerData.address?.cityName || "";
      this.partner.address.state = partnerData.address?.state || "";

      this.partner.user = partnerData.users?.[0] || {};
      this.partner.associates = partnerData.associates || [];
      this.partner.businessHours = partnerData.businessHours || [];
      this.partner.contractFile = partnerData.contractFile || "";
      this.partner.registrationStatusFile =
        partnerData.registrationStatusFile || "";
      this.partner.partnerConfigs.id = partnerData.partnerConfigs?.id || 0;
      this.partner.partnerConfigs.onlineSale =
        partnerData.partnerConfigs?.onlineSale || false;
      this.partner.partnerConfigs.pdvSale =
        partnerData.partnerConfigs?.pdvSale || false;
      this.partner.partnerConfigs.updatedAt =
        partnerData.partnerConfigs?.updatedAt || "";
      this.partner.partnerConfigs.instantCashback =
        partnerData.partnerConfigs?.instantCashback || 0;

      this.partner.description = partnerData.description || "";
      this.partner.instagram = partnerData.instagram || "";
      this.partner.whatsapp = partnerData.whatsapp || "";

      // Mapeia as imagens do backend e define o status como 'unchanged'
      this.partner.images = (partnerData.images || []).map((img: any) => ({
        type: img.type,
        image: img.image,
        status: "unchanged", // Define o status inicial
      }));

      // Limpa os previews locais ao carregar dados do backend
      this.logoPreviewUrl = "";
      this.coverPreviewUrl = "";
      this.galleryPreviewUrls = [];

      // Cria uma cópia profunda para comparação ao atualizar
      this.originalPartnerImages = JSON.parse(
        JSON.stringify(this.partner.images || [])
      );

      partnerData.document?.length > 11
        ? (this.partner.typeCompany = "PJ")
        : (this.partner.typeCompany = "PF");

      // Verificar se está conectado ao PagBank baseado no accountNumber ANTES de chamar a API
      if (this.partner.digitalAccountNumber?.startsWith("ACCO")) {
        this.pagBankStatus.connected = true;
        this.pagBankStatus.pagbankConnect = true;
      }

      // Verificar status da conexão PagBank
      await this.handleGetPagBankStatus();

      const { hasPending } = validateOnboardingData(partnerData);
      this.$store.commit("SET_ONBOARDING_PENDING", hasPending);

      this.loading = false;
    },
    async handleGetAllCategories() {
      let categories = new GetAllCategories();
      let dataCategories = await categories.execute();
      this.categories = dataCategories.data;
    },
    async handleAddress() {
      const getAddress = new GetAddress();
      const address = await getAddress.execute(this.partner.address.zipCode);
      if (address) {
        this.partner.address.street = address.logradouro;
        this.partner.address.neighborhood = address.bairro;
        this.partner.address.cityName = address.localidade || "";
        this.partner.address.state = address.uf || "";
        this.partner.address.ibge = address.ibge || "";
      }
    },

    openImageDialog(src: string) {
      this.dialogImageSrc = src;
      this.dialog = true;
    },

    // Novo método para obter a URL de preview (local ou do backend)
    getPreviewImage(type: "LOGO" | "COVER"): string {
      if (type === "LOGO" && this.logoPreviewUrl) {
        return this.logoPreviewUrl;
      }
      if (type === "COVER" && this.coverPreviewUrl) {
        return this.coverPreviewUrl;
      }
      // Garante que partner.images não é null/undefined antes de chamar find
      const imageObj = this.partner.images?.find((img) => img.type === type);
      return imageObj && imageObj.status !== "deleted" ? imageObj.image : "";
    },

    // Novo método para obter as URLs de preview da galeria (local ou do backend)
    getPreviewImages(type: "GALLERY"): string[] {
      if (this.galleryPreviewUrls.length > 0) {
        return this.galleryPreviewUrls;
      }
      // Garante que partner.images não é null/undefined antes de chamar filter
      return (
        this.partner.images
          ?.filter((img) => img.type === type && img.status !== "deleted")
          .map((img) => img.image) || []
      );
    },

    handleConvertForBase64(
      type: "LOGO" | "COVER" | "GALLERY",
      isMultiple: boolean = false
    ) {
      if (this.isProcessingImage) return;
      this.isProcessingImage = true;

      if (isMultiple) {
        // Verifica se galleryFiles existe e não está vazio
        if (!this.galleryFiles || this.galleryFiles.length === 0) {
          this.isProcessingImage = false;
          // Se o input foi limpo, chama a lógica de remoção
          this.clearGalleryFiles();
          return;
        }

        // Primeiro, gera as URLs de preview para os arquivos locais da galeria
        this.galleryPreviewUrls = this.galleryFiles.map((file) =>
          URL.createObjectURL(file)
        );

        const currentActiveGalleryCount = (this.partner.images || []).filter(
          (img) => img.type === "GALLERY" && img.status !== "deleted"
        ).length;
        const newFilesCount = this.galleryFiles.length;

        if (currentActiveGalleryCount + newFilesCount > 3) {
          this.$store.dispatch("showSnack", {
            message: "Você pode adicionar no máximo 3 imagens de publicidade.",
            color: "red",
          });
          this.galleryFiles = [];
          this.galleryPreviewUrls = []; // Limpa os previews se a validação falhar
          this.isProcessingImage = false;
          return;
        }

        // Marca as imagens da galeria existentes como "deleted" para substituição
        if (this.partner.images) {
          this.partner.images.forEach((img) => {
            if (img.type === "GALLERY" && img.status !== "deleted") {
              img.status = "deleted";
            }
          });
        }

        // Converte os novos arquivos para Base64 e atualiza o partner.images
        let processedCount = 0;
        this.galleryFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64Image = reader.result as string;
            this.updateImageInPartner(
              "GALLERY",
              base64Image.replace(/^data:[^;]+;base64,/, "")
            );
            processedCount++;
            if (processedCount === newFilesCount) {
              this.isProcessingImage = false;
            }
          };
          reader.onerror = (error) => {
            console.error("Erro ao ler o arquivo da galeria", error);
            this.isProcessingImage = false;
          };
          reader.readAsDataURL(file);
        });
      } else {
        // Para LOGO e COVER (arquivo único)
        let fileToProcess: File | null = null;
        if (type === "LOGO") {
          fileToProcess = this.logoFile;
        } else if (type === "COVER") {
          fileToProcess = this.coverFile;
        }

        if (fileToProcess) {
          // Gera URL de preview para o arquivo local
          if (type === "LOGO") {
            this.logoPreviewUrl = URL.createObjectURL(fileToProcess);
          } else if (type === "COVER") {
            this.coverPreviewUrl = URL.createObjectURL(fileToProcess);
          }

          const reader = new FileReader();
          reader.onload = () => {
            const base64Image = reader.result as string;
            this.updateImageInPartner(
              type,
              base64Image.replace(/^data:[^;]+;base64,/, "")
            );
            this.isProcessingImage = false;
          };
          reader.onerror = (error) => {
            console.error(`Erro ao ler o arquivo para ${type}`, error);
            this.isProcessingImage = false;
          };
          reader.readAsDataURL(fileToProcess);
        } else {
          // Se o arquivo foi limpo, remove a imagem e o preview
          this.removeImage(type);
          this.isProcessingImage = false;
        }
      }
    },

    updateImageInPartner(
      type: "LOGO" | "COVER" | "GALLERY",
      base64String: string
    ) {
      if (!this.partner.images) {
        this.partner.images = [];
      }

      if (type === "GALLERY") {
        const currentActiveGalleryCount = (this.partner.images || []).filter(
          (img) => img.type === "GALLERY" && img.status !== "deleted"
        ).length;
        if (currentActiveGalleryCount < 3) {
          this.partner.images.push({
            type,
            image: base64String,
            status: "added",
          });
        }
      } else {
        // Para LOGO e COVER, remove a imagem antiga (se houver e não estiver deletada)
        // e adiciona a nova Base64.
        const existingIndex = this.partner.images.findIndex(
          (img) => img.type === type && img.status !== "deleted"
        );
        if (existingIndex !== -1) {
          // Marca a imagem antiga como deleted
          this.partner.images[existingIndex].status = "deleted";
        }
        // Adiciona a nova imagem Base64
        this.partner.images.push({
          type,
          image: base64String,
          status: "added",
        });
      }
    },

    removeImage(type: "LOGO" | "COVER" | "GALLERY", index?: number) {
      if (!this.partner.images) return;

      if (type === "GALLERY" && index !== undefined) {
        const galleryImages = this.partner.images.filter(
          (img) => img.type === "GALLERY" && img.status !== "deleted"
        );
        if (index < galleryImages.length) {
          const imageToRemove = galleryImages[index];
          const actualIndexInAllImages = this.partner.images.findIndex(
            (img) => img === imageToRemove
          );
          if (actualIndexInAllImages !== -1) {
            this.partner.images[actualIndexInAllImages].status = "deleted";
          }
        }
        // Limpa o preview e o v-model do input de arquivo para refletir a remoção visualmente
        this.galleryFiles.splice(index, 1);
        this.galleryPreviewUrls.splice(index, 1);
      } else if (type === "LOGO" || type === "COVER") {
        const existingIndex = this.partner.images.findIndex(
          (img) => img.type === type && img.status !== "deleted"
        );
        if (existingIndex !== -1) {
          this.partner.images[existingIndex].status = "deleted";
        }
        // Limpa o v-model e a URL de preview para refletir a remoção na UI
        if (type === "LOGO") {
          this.logoFile = null;
          this.logoPreviewUrl = "";
        } else {
          this.coverFile = null;
          this.coverPreviewUrl = "";
        }
      }
    },

    clearGalleryFiles() {
      // Marca todas as imagens da galeria como "deleted"
      this.partner.images?.forEach((img) => {
        if (img.type === "GALLERY" && img.status !== "deleted") {
          img.status = "deleted";
        }
      });
      this.galleryFiles = []; // Limpa o v-model
      this.galleryPreviewUrls = []; // Limpa os previews
    },

    rulesMaxGalleryImages(files: File[]) {
      // Conta as imagens ativas (não deletadas)
      const currentActiveGalleryCount = (this.partner.images || []).filter(
        (img) => img.type === "GALLERY" && img.status !== "deleted"
      ).length;
      const totalAfterAdd = currentActiveGalleryCount + files.length;

      return (
        totalAfterAdd <= 3 ||
        `Máximo de 3 imagens de publicidade permitidas. Você tem ${currentActiveGalleryCount} e tentou adicionar ${files.length} novas, totalizando ${totalAfterAdd}.`
      );
    },

    handleUpdatePartner() {
      const updatePartnerData = new UpdatePartner();
      const payloadToSend = { ...this.partner };

      const imagesToSend: PartnerImage[] = [];

      if (this.partner.images) {
        // Remove os que estão com status 'deleted' do array original
        this.partner.images = this.partner.images.filter(
          (img) => img.status !== "deleted"
        );

        // Monta o array para enviar (apenas os com status 'added' ou outros válidos)
        this.partner.images.forEach((img) => {
          if (img.status === "added") {
            imagesToSend.push({
              image: img.image,
              type: img.type,
              status: img.status,
            });
          } else {
            // Aqui você decide se quer enviar os 'unchanged' ou outros
            imagesToSend.push({
              image: img.image,
              type: img.type,
              status: img.status,
            });
          }
        });

        payloadToSend.images = imagesToSend;
      }

      if (!payloadToSend.images || payloadToSend.images.length === 0) {
        delete payloadToSend.images;
      }

      updatePartnerData
        .execute(payloadToSend)
        .then(() => {
          this.$store.dispatch("showSnack", {
            message: "Os dados foram atualizados com sucesso",
            color: "green",
          });
          // Recarrega os dados para resetar os status das imagens e buscar as URLs atualizadas
          this.handleGetDataPartner();
        })
        .catch(() => {
          this.$store.dispatch("showSnack", {
            message: "Erro ao atualizar os dados, tente novamente mais tarde",
            color: "red",
          });
        });
    },
    async handleGetPagBankStatus() {
      try {
        const getPagBankStatus = new GetPagBankStatus();
        const status = await getPagBankStatus.execute();
        this.pagBankStatus = {
          connected: status.connected || false,
          pagbankConnect: !!status.pagbankConnect,
          accountId: status.accountId,
          accountName: status.accountName,
        };
      } catch (error) {
        console.error("Erro ao verificar status PagBank:", error);
        const isConnected = this.partner.digitalAccountNumber?.startsWith("ACCO") || false;
        this.pagBankStatus = {
          connected: isConnected,
          pagbankConnect: isConnected,
          accountId: undefined,
          accountName: undefined,
        };
      }
    },
    handleConnectPagBank() {
      this.showPagBankConnectDialog = true;
    },
    async handlePagBankConnected() {
      await this.handleGetDataPartner();
      await this.handleGetPagBankStatus();
    },
    handleLogoError(_processor: string, event: Event) {
      const img = event.target as HTMLImageElement;
      img.src =
        'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 200 60%22%3E%3Ctext x=%2210%22 y=%2235%22 font-size=%2220%22 font-weight=%22bold%22 fill=%22%2300A859%22%3EPagBank%3C/text%3E%3C/svg%3E';
    },
    handleRouteIntents() {
      const query = this.$route?.query || {};
      let shouldCleanQuery = false;

      const tabMap: Record<string, number> = {
        bank: 2,
        hours: 3,
        info: 4,
      };

      const requestedTab = typeof query.tab === "string" ? tabMap[query.tab] : undefined;
      if (typeof requestedTab === "number") {
        this.tab = requestedTab;
        shouldCleanQuery = true;
      }

      if (query.pagbankConnected === "true") {
        this.$store.dispatch("showSnack", {
          message: "Conta conectada com sucesso",
          color: "success",
        });
        shouldCleanQuery = true;
      }

      if (shouldCleanQuery) {
        const sanitizedQuery = { ...query } as Record<string, any>;
        delete sanitizedQuery.tab;
        delete sanitizedQuery.pagbankConnected;

        this.$router.replace({
          path: this.$route.path,
          query: sanitizedQuery,
        });
      }
    },
  },
  watch: {
    $route() {
      this.handleRouteIntents();
    },
  },
  computed: {
    isPagBankConnected(): boolean {
      return (
        this.partner.digitalAccountNumber?.startsWith("ACCO") ||
        this.pagBankStatus.pagbankConnect ||
        this.pagBankStatus.connected
      );
    },
  },
  mounted() {
    this.handleGetDataPartner();
    this.handleGetAllCategories();
    this.handleRouteIntents();
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.partner-detail-page {
  width: 100%;
  color: $br-ink;
}

.partner-detail-tabs {
  margin-bottom: $br-space-4;
  border-radius: $br-radius-lg;
  border: 1px solid $br-border-soft;
  box-shadow: $br-shadow-sm;
  overflow: hidden;
}

.partner-detail-card {
  border-radius: $br-radius-lg !important;
  border: 1px solid $br-border-soft !important;
  background: $br-bg-elevated !important;
  box-shadow: $br-shadow-sm !important;
  overflow: hidden;
  margin-bottom: $br-space-5;
}

.partner-detail-subcard {
  border-radius: $br-radius-md !important;
  border-color: $br-border-soft !important;
  background: $br-bg-subtle !important;
}

.partner-detail-subcard--dashed {
  border-style: dashed !important;
  border-width: 2px !important;
  background: $br-bg-elevated !important;
  transition: border-color $br-transition-base, background $br-transition-base;

  &:hover {
    border-color: $br-brand !important;
    background: rgba(229, 24, 61, 0.03) !important;
  }
}

.partner-detail-subcard--upload {
  background: $br-bg-elevated !important;
  transition: box-shadow $br-transition-base;

  &:hover {
    box-shadow: $br-shadow-sm !important;
  }
}

.partner-detail-muted {
  color: $br-muted !important;
}

.partner-detail-dialog-img {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}

.br-form-field {
  margin-bottom: $br-space-2;
}

.add-button,
.delete-button {
  transition: transform $br-transition-fast;

  &:hover {
    transform: scale(1.06);
  }
}

.table-row {
  transition: background-color $br-transition-fast;

  &:hover {
    background-color: rgba(229, 24, 61, 0.03);
  }
}

.image-preview-container {
  margin-top: $br-space-4;
  position: relative;
}

.image-preview-card,
.gallery-preview-card {
  border-radius: $br-radius-sm;
  overflow: hidden;
  position: relative;
  border: 1px solid $br-border-soft;
  transition: transform $br-transition-base, box-shadow $br-transition-base;

  &:hover {
    transform: translateY(-1px);
    box-shadow: $br-shadow-sm;
  }
}

.preview-image {
  width: 100%;
  height: 150px;
  object-fit: contain;
  cursor: pointer;
  background: $br-bg;
  border-radius: $br-radius-sm;
  transition: opacity $br-transition-fast;

  &:hover {
    opacity: 0.9;
  }
}

.preview-image[alt="Logo"] {
  aspect-ratio: 1/1;
  height: 150px;
  width: 150px;
  margin: 0 auto;
  display: block;
}

.preview-image[alt="Banner"] {
  aspect-ratio: 410/180;
  height: 120px;
  width: 100%;
}

.preview-image[alt*="Publicidade"] {
  aspect-ratio: 800/1000;
  height: 150px;
  width: 100%;
}

.remove-image-btn,
.gallery-remove-btn {
  position: absolute;
  top: $br-space-2;
  right: $br-space-2;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(4px);
}

.gallery-remove-btn {
  top: $br-space-1;
  right: $br-space-1;
}

.gallery-preview-image {
  width: 100%;
  height: 120px;
  object-fit: contain;
  cursor: pointer;
  background: $br-bg;
  border-radius: $br-radius-sm;
  aspect-ratio: 800/1000;
  transition: opacity $br-transition-fast;

  &:hover {
    opacity: 0.9;
  }
}

.update-button {
  font-weight: 600;
  padding: 12px 28px;
  border-radius: $br-radius-sm;
  transition: transform $br-transition-base;

  &:hover {
    transform: translateY(-1px);
  }
}

.dimensions-images-text {
  font-size: $br-font-size-xs;
  color: $br-muted;
}

.processor-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
}

.processor-logo {
  max-width: 150px;
  max-height: 60px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .spacing {
    margin-bottom: 100px;
  }

  .partner-detail-tabs ::v-deep .v-slide-group__content {
    justify-content: flex-start !important;
  }
}
</style>
